import React, { Fragment, useEffect, useState } from 'react';
import Cluster from '../../models/Cluster';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';

const FormPartial = (props) => {
  const { cluster, setCluster } = props;
  let clusterObj = new Cluster(cluster);
  const [branches, setBranches] = useState([]);
  const [branchesApi] = getApi('branches');

  useEffect(() => {
    fetchApiData(branchesApi, "branches", { fields: 'options' }, setBranches);
  }, [])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      let response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      toast.error(error.data.message || "Something Went Wrong !");
    }
  }

  const validateValue = (field) => {
    clusterObj.validate(field);
  }

  const changeValue = (field, value) => {
    clusterObj[field] = value;
    validateValue(field);
    setCluster(clusterObj.toStateJson());
  }

  const onBranchSelect = (selectedList, selectedItem) => {
    clusterObj.branch = selectedItem;
    validateValue('branch');
    setCluster(clusterObj.toStateJson());
  }

  return <Fragment>
    <div className="row mt-4">
      <div className="col-md-4 my-2">
        <label htmlFor="name" className="form-label">Name</label>
        <input
          id="name"
          value={clusterObj.name.toUpperCase()}
          onChange={(e) => changeValue('name', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Name'
          aria-describedby="name_help"
        />
        <div id="name_help" className="form-text text-danger mt-0">
          {clusterObj.errors.name}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="branch" className='form-label'>Select Circle</label>
        <Multiselect
          id="branch"
          options={branches}
          selectedValues={clusterObj.branch ? [clusterObj.branch] : []}
          onSelect={onBranchSelect}
          placeholder='Select from options'
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          singleSelect={true}
          avoidHighlightFirstOption={true}
        />
        <div id="zone_help" className="form-text text-danger mt-0">
          {clusterObj.errors.branch}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="sap_code" className='form-label'>SAP Code</label>
        <input
          id="sap_code"
          value={clusterObj.sap_code}
          onChange={(e) => changeValue('sap_code', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Cluster Code'
          aria-describedby="sap_code_help"
          maxLength={4}
        />
        <div id="sap_code_help" className="form-text text-danger mt-0">
          {clusterObj.errors.sap_code}
        </div>
      </div>
    </div>
  </Fragment>
}

export default FormPartial;
